import { httpV2 } from "../http";

const rolesService = {
  /** All roles visible to the current account (system + custom) */
  listRoles: () => httpV2.get("/roles"),

  /** Single role with full permissions matrix */
  getRole: (roleId) => httpV2.get(`/roles/${roleId}`),

  /** Create a new custom role */
  createRole: (data) => httpV2.post("/roles", data),
  duplicateRole: (roleId, data) => httpV2.post(`/roles/${roleId}/duplicate`, data),

  /** Update role name / description */
  updateRole: (roleId, data) => httpV2.put(`/roles/${roleId}`, data),

  /** Replace the full permission matrix for a custom role */
  setPermissions: (roleId, permissions) =>
    httpV2.put(`/roles/${roleId}/permissions`, { permissions }),

  /** Delete a custom role */
  deleteRole: (roleId) => httpV2.delete(`/roles/${roleId}`),

  /** All permission module definitions */
  listModules: () => httpV2.get("/permissions/modules"),

  /** Effective permissions for the current user (called on login) */
  getEffectivePermissions: () => httpV2.get("/permissions/effective"),

  /** Audit log for the account */
  listAudit: (limit = 200) => httpV2.get(`/roles/audit?limit=${limit}`),

  /** Recipients with their assigned roles */
  listRecipientsWithRoles: () => httpV2.get("/roles/recipients"),

  /** Roles assigned to a specific recipient */
  getRecipientRoles: (recipientId) => httpV2.get(`/teams/${recipientId}/roles`),

  /** Assign a single role to a recipient */
  assignRole: (recipientId, roleId) =>
    httpV2.post(`/teams/${recipientId}/roles`, { role_id: roleId }),

  /** Remove a single role from a recipient */
  removeRole: (recipientId, roleId) =>
    httpV2.delete(`/teams/${recipientId}/roles/${roleId}`),

  /** Replace the recipient's assigned role; pass null to clear it */
  setRecipientRole: (recipientId, roleId) =>
    httpV2.put(`/teams/${recipientId}/roles`, { role_id: roleId }),
};

export default rolesService;
